import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useIntl } from "react-intl";

type HandoutOrderingNotAllowedDialogProps = {
  open: boolean;
  onClose: () => void;
};

export default function HandoutOrderingNotAllowedDialog({
  open,
  onClose,
}: HandoutOrderingNotAllowedDialogProps) {
  const { formatMessage: t } = useIntl();

  return (
    <Dialog open={open} maxWidth="xs">
      <DialogTitle>{t({ id: "errorLabel" })}</DialogTitle>
      <DialogContent>
        <Alert severity="error">
          {t({ id: "cantReorderWithProductLevelHandouts" })}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t({ id: "okButton" })}</Button>
      </DialogActions>
    </Dialog>
  );
}
